var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIllustrationSolar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3158_31654)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.7578,
    cy: 40.3418,
    r: 19.9453,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5391,
    cy: 40.126,
    r: 14,
    fill: "url(#paint0_linear_3158_31654)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.625 33.9738C33.7092 33.7251 33.9435 33.5569 34.2066 33.5557H47.3108C47.574 33.5569 47.8083 33.7251 47.8924 33.9738L50.5682 41.7779C50.6331 41.9653 50.6019 42.1732 50.4865 42.3354C50.3712 42.4964 50.1849 42.5925 49.9867 42.5925H41.374V45.7909L43.389 45.7921C43.729 45.7921 44.0042 46.0673 44.0042 46.4073C44.0042 46.7473 43.729 47.0225 43.389 47.0225H38.1284C37.7884 47.0225 37.5133 46.7473 37.5133 46.4073C37.5133 46.0673 37.7884 45.7921 38.1284 45.7921H40.1435V42.5925H31.5307C31.3325 42.5925 31.1462 42.4964 31.0309 42.3353C30.9155 42.1731 30.8843 41.9653 30.9492 41.7778L33.625 33.9738ZM43.1449 41.3561L42.9118 39.3664H38.6054L38.3783 41.3621L43.1449 41.3561ZM42.776 38.1359L42.6282 36.8322H38.8891L38.7413 38.1359H42.776ZM47.5714 36.8322H43.8803L44.0161 38.1359H48.0148L47.5714 36.8322ZM39.1221 34.7872L39.0295 35.6018H42.4875L42.395 34.7872H39.1221ZM37.6514 36.8322H33.9457L33.4964 38.1359H37.4951L37.6514 36.8322ZM34.3662 35.6018H37.7932L37.8857 34.7872L34.6464 34.786L34.3662 35.6018ZM43.6314 34.786L43.7239 35.6006L47.1508 35.6018L46.8709 34.7872L43.6314 34.786ZM48.4483 39.3664H44.142L44.3691 41.3622H49.1248L48.4483 39.3664ZM37.1405 41.3622L37.3748 39.3664H33.0684L32.3859 41.3622H37.1405Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3158_31654",
    x: 0.8125,
    y: 0.396484,
    width: 79.8906,
    height: 79.8906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.114844 0 0 0 0 0.222396 0 0 0 0 0.4375 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3158_31654"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3158_31654",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3158_31654",
    x1: 51.5763,
    y1: 26.6513,
    x2: 20.4021,
    y2: 36.5343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustrationSolar);
export default __webpack_public_path__ + "static/media/home_illustration_solar.e04cbb158b7a9e846cc65db618205481.svg";
export { ForwardRef as ReactComponent };